// extracted by mini-css-extract-plugin
export default {"smart":"smart_smart__5vNuG"};